export interface ModulePurchasePrompt {
  key: string
  title: string
}

export function useModulePurchasePrompt() {
  const prompt = useState<ModulePurchasePrompt | null>('module-purchase-prompt', () => null)

  function openModulePurchase(key: string, title: string) {
    prompt.value = { key, title }
  }

  function closeModulePurchase() {
    prompt.value = null
  }

  return { prompt, openModulePurchase, closeModulePurchase }
}
